import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBurst: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBurst"><Path d="M12 1.5V4.5M12 19.5V22.5M1.5 12H4.5M19.5 12H22.5M4.5 4.5L8 8M16 16L19.5 19.5M4.5 19.5L8 16M16 8L19.5 4.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBurst;
